module.exports = __webpack_public_path__ + "img/menu.82f3287d.png";